import { PaneArea } from '../../../types/shared'
import FR, { IFibonacciRetracementsAttrs } from '../../canvas/fibonacci_retracements'
import PaneModel from '../../models/pane'

type Area = PaneArea
type Attrs = IFibonacciRetracementsAttrs
type PartialAttrs = Partial<Attrs>

class FRCreator extends FR<Attrs> {
  isCreator = true

  constructor(startArea: Area, values: PartialAttrs, model: PaneModel, _: unknown, toolsCallback: () => void) {
    super(values, model)

    const width = this.model.scale.x.width(120)
    const height = this.model.scale.y.height(80)
    this.attrs.x1 = startArea.x - width
    this.attrs.x2 = startArea.x + width
    this.attrs.y1 = startArea.y - height
    this.attrs.y2 = startArea.y + height

    setTimeout(() => {
      this.replaceMyself(FR.fromObject<FR>(this.attrs, this.model))
      toolsCallback()
    })

    window.gtag?.('event', 'create', { event_category: 'tools', event_label: this.name })
  }
}

export default FRCreator
